import BaseNMComAdapter from "adapters/base.nmcom.adapter";
import BaseNMComCollection from "collections/base.nmcom.collection";

export default class SearchAdapter extends BaseNMComAdapter {
	static receiveResponse(response, object, options) {
		if(object instanceof BaseNMComCollection) {
			let {body} = response || {};
			let {resultCount, start} = body || {};

			let pageNumber = 0;
			start = start || 0;
			if(start > 0) {
				pageNumber = Math.floor(start / object.getPageSize());
			}

			object.setResultCount(resultCount || 0);
			object.setPageNumber(pageNumber)

		}
	}

	static standardizeOptions(object, options = {}) {
		options['baseUrl'] = options['baseUrl'] || "<%=searchApiBaseUrl%>";
		options['params'] = Object.assign({}, options['params'], object['params']);
		options['params']['page[size]'] = object.getPageSize();
		options['params']['page[number]'] = object.getPageNumber();
		return super.standardizeOptions(object, options);
	}
}
